import type { FieldProps } from '@hover/blueprint';
import { Field } from '@hover/blueprint';
import { Dropdown } from '@hover/dropdown';
import type { DropdownProps } from '@hover/dropdown';
import React from 'react';
import { useFormContext } from 'react-hook-form';

export interface DropdownFieldProps<Item>
  extends Pick<FieldProps, 'label'>,
    DropdownProps<Item> {
  name: string;
}

const DropdownField = <Item extends {}>({
  name,
  label,
  ...props
}: DropdownFieldProps<Item>) => {
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { errors, register } = useFormContext<Record<string, string>>();

  const error = errors[name]?.message;

  return (
    <Field error={error} label={label} name={name}>
      <Dropdown {...props} ref={register} />
    </Field>
  );
};

export { DropdownField };
